export default "__VITE_PUBLIC_ASSET__e564cd5e__"